import { useContext, useEffect, useRef } from "react";
import { MapContext } from "../../../../helpers";
import { Vector2 } from "@app/shared";

export type CircleMapShapeProps = {
    position?: google.maps.LatLng | Vector2;
    radius?: number;
    color?: string;
    opacity?: number;
    isEditable?: boolean;
    isSelected?: boolean;
    onUpdate?: (position: google.maps.LatLng | null) => void;
    onClick?: (e: google.maps.MapMouseEvent) => void;
};
export const CircleMapShape: React.FC<CircleMapShapeProps> = ({ position, color, radius, opacity, isEditable, isSelected, onClick, onUpdate }) => {
    const [parentMap, setBounds] = useContext(MapContext);

    const circle = useRef<google.maps.marker.AdvancedMarkerElement>();

    useEffect(() => {
        //create/update google poly for shape
        if (!circle.current && parentMap && position) {
            circle.current = initPoly(position, parentMap, color, radius, opacity);
            setBounds((curr) => {
                const pos = circle.current?.position;
                if (pos) curr.extend(pos as google.maps.LatLng);
                return curr;
            });
        } else if (circle.current) {
            circle.current = updatePoly(circle.current, position, parentMap, color, radius);
        }
        return () => {
            if (circle.current) circle.current.map = null;
            circle.current = undefined;
        };
    }, [parentMap, circle, position, color, radius]); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        //editable
        let drag: google.maps.MapsEventListener, dragEnd: google.maps.MapsEventListener;
        if (isEditable && parentMap && circle.current) {
            drag = parentMap.addListener("drag", (e: google.maps.MapMouseEvent) => onClick?.(e));
            dragEnd = parentMap.addListener("dragend", (e: google.maps.MapMouseEvent) => onUpdate?.(e.latLng));
        }
        return () => {
            drag?.remove();
            dragEnd?.remove();
        };
    }, [isEditable, parentMap, circle, onClick, onUpdate]);

    useEffect(() => {
        //selection from map
        let click: google.maps.MapsEventListener;
        if (onClick && parentMap && circle.current) {
            click = circle.current.addListener("click", (e: google.maps.MapMouseEvent) => onClick?.(e));
        }
        return () => {
            click?.remove();
        };
    }, [onClick, parentMap, circle]);
    return null;
};

function initPoly(position: google.maps.LatLng | Vector2, parentMap: google.maps.Map, color?: string, radius?: number, opacity?: number): google.maps.marker.AdvancedMarkerElement | undefined {
    if ("lat" in position) {
    } else {
        const p = position as Vector2;
        position = new google.maps.LatLng({ lat: p.y, lng: p.x });
    }

    const circleElement = document.createElement("div");
    const size = (radius ?? 5) * 2;
    circleElement.style.width = `${size}px`;
    circleElement.style.height = `${size}px`;
    circleElement.style.borderRadius = "50%";
    circleElement.style.backgroundColor = color ?? "red";
    circleElement.style.border = `1px solid ${color ?? "red"}`;
    circleElement.style.opacity = `${opacity ?? 1.0}`;

    return new google.maps.marker.AdvancedMarkerElement({
        position: position,
        map: parentMap,
        content: circleElement,
    });
}

function updatePoly(poly: google.maps.marker.AdvancedMarkerElement, position: google.maps.LatLng | Vector2 | undefined, parentMap: google.maps.Map | undefined, color?: string, radius?: number): google.maps.marker.AdvancedMarkerElement | undefined {
    poly.map = parentMap ?? null;
    if (!parentMap || !position) {
        return undefined;
    }

    if ("lat" in position) {
    } else {
        const p = position as Vector2;
        position = new google.maps.LatLng({ lat: p.y, lng: p.x });
    }

    const circleElement = document.createElement("div");
    const size = (radius ?? 5) * 2;
    circleElement.style.width = `${size}px`;
    circleElement.style.height = `${size}px`;
    circleElement.style.borderRadius = "50%";
    circleElement.style.backgroundColor = color ?? "red";
    circleElement.style.border = `1px solid ${color ?? "red"}`;

    poly.content = circleElement;
    poly.position = position;
    return poly;
}
